import styled from 'styled-components';

export const BluSmartTile = styled.div`
  display: flex;
  background:#fff;
  border-radius:4px;
  overflow:hidden;
  border:solid 1px #fff;

  .knowMore {
    margin-left:auto;
    color:#2276e3;
    cursor:pointer;
    font-size:12px;
  }

  .branding {
    padding:6px 10px 6px 10px;
    position:relative;
    display:flex;
    align-items:center;
  }

  .assuredStrip {
    background: linear-gradient(135deg, #1149F3 0%, #00C3FF 100%);
    padding:6px 10px 6px 30px;
    flex:1;
    position:relative;
  }

  .assuredStrip:before {
    content:"";
    position:absolute;
    border-style:solid;
    border-width:28px 0 28px 20px;
    border-color: transparent transparent transparent #fff;
    top:-4px;
    left:0px;
  }


  .assuredStrip .dtls {
    padding:6px 16px 6px 6px;
    display:flex;
    align-items: center;
    border-radius:4px;
    background:#fff;
  }
`;

export const MessageText = styled.span(
  props => `
      p {
        font-weight: 600;
        color: ${props?.textColor || "#000"}
      }
      text {
        color: ${props?.subTextColor || "#18A160"};
      }
  `
)

export const BluSmartImg = styled.img.attrs((props) => ({
  src: props.src || "",
  }))`
  width: 60px;
  height: 30px;
`;

export const GoAssuredImg = styled.img.attrs((props) => ({
  src: props.src || "",
  }))`
  width: 102px;
  height: 30px;
`;

